<div class="px-3">
  <div class="ps-1 pt-3">
    <b class="text-break py-md-1"> {{ 'PROFILE_VIEW_SPECIALIZATION_HINT' | translate }}: </b>
    <span [attr.data-test-id]="'specialtys'">
      {{ specialtys | formatCategories }}
    </span>
  </div>

  <div *ngIf="education" class="ps-1 pt-1">
    <b class="text-break py-md-1"> {{ 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_EDUCATION_LABEL' | translate }}: </b>
    <span [attr.data-test-id]="'education'">
      {{ education | translate }}
    </span>
  </div>

  <div *ngIf="fellowship" class="ps-1 pt-1">
    <b class="text-break py-md-1"> {{ 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_FELLOWSHIP_LABEL' | translate }}: </b>
    <span [attr.data-test-id]="'fellowship'">
      {{ fellowship | translate }}
    </span>
  </div>

  <div *ngIf="treatmentDiseases?.length > 0" class="ps-1 pt-1">
    <b class="text-break py-md-1"> {{ 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_DISEASES_LABEL' | translate }}: </b>
    <span [attr.data-test-id]="'treatmentDiseases'">
      {{ treatmentDiseases | formatCategories }}
    </span>
  </div>

  <div class="ps-1 pt-1 pb-3">
    <b class="text-break py-md-1">
      {{ 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_ORGANIZATION_NAME_LABEL' | translate }}:
    </b>

    <app-role-navigation-organization
      [organizationLinkUrlParams]="organizationLinkUrlParams"
      class="text-break"
    ></app-role-navigation-organization>
  </div>
</div>
